// TestIDs are categorize by 3 ways, Pages, Features, and Components

// Pages are TestIDs for the whole page

// Features are TestIDs that is primarily used on the feature,
// The components would not exist without the feature, such as agreement, order, product,

// Components are TestIDs that is primarily used on reused component that are used
// throughout different features, such as the header, footer, etc.

// * Only three levels of TestIDs are allowed
// * "Pages", "Feat", "Components" are the only items are allowed on root level

// For Pages
// the first level should be the page name.
//    - Example: "feat.agreement.tabview.pastAgreements"
//

// For Features
// the first level should be the feature name, and
// the second level should be the group name.
// the thrid level should be the element
//    - Example: "feat.agreement.tabview.pastAgreements"
//

// For Components
// the first level should be the component name, and
// the 2nd level should be the element.
//    - Example: "component.contactCard.storeName"
//

export const TestIds = {
  pages: {
    pastProducts: 'past-products-page',
    productDetails: 'product-details-page',
    productNotFound: 'product-not-found',
    cart: 'cart-page',
    salesAgreements: 'sales-agreements-home',
    salesAgreement: 'sales-agreements-details',
    orders: 'orders-page',
    orderDetails: 'order-details',
    quotes: 'quotes-page',
    quoteDetails: 'quote-details',
    quoteOrderSubmitted: 'quote-order-submitted',
    requestAQuoteSuccess: 'request-a-quote-success',
    home: 'home-page',
    drawdownSuccess: 'drawdown-success',
    noShareHolderAccess: 'not-a-shareholder',
    mixedAccessShareholderAccess: 'mixed-access',
    mainScrollContainer: 'main-scroll-container',
    maintenancePage: 'maitenance-page',
    seedOrder: 'seed-order',
    seedOrderSummary: 'seed-order-summary',
    seedOrderSuccess: 'seed-order-success',
    versionMismatch: 'version-mismatch-page',
  },
  feat: {
    dashboard: {
      list: {
        dashboardHelperMessage: 'dashboard-helperMessage',
        viewAllProducts: 'dashboard-viewAllProducts',
        viewAllAgreements: 'dashboard-viewAllAgreements',
        viewAllOrders: 'dashboard-viewAllorders',
      },
    },
    agreement: {
      tabView: {
        pastAgreements: 'past-agreements-tab-button',
        activeAgreements: 'active-agreements-tab-button',
        activeAgreementsList: 'active-sales-agreements-list',
        pastAgreementsList: 'past-sales-agreements-list',
        upcomingAgreementsList: 'upcoming-sales-agreements-list',
      },
      list: {
        noAgreementsMessage: 'noAgreements-message',
        noAgreementsContactBox: 'noAgreements-contact',
      },
      card: {
        agreementCard: 'sales-agreement-card',
        name: 'agreements-Name',
        date: 'agreements-Date',
        timeBadge: 'agreements-TimeBadge',
        fulfillmentBar: 'agreements-Fulfillment',
        product: 'agreements-Products',
      },
      salesOrder: {
        table: 'agreements-sales-order-table',
        tableItem: 'agreements-sales-order-table-item',
      },
      salesLines: {
        container: 'sales-lines-list-container',
        item: 'sales-lines-list-item',
        productDescription: 'line-product-desc',
        agreementTotalLabel: 'line-agreement-total-label',
        agreementTotal: 'line-agreement-total',
        boughtPriceLabel: 'line-bought-price-label',
        boughtPrice: 'line-brought-price',
        remaining: 'line-remaining',
        fulfilled: 'line-fulfilled',
        fulfillmentBar: 'line-fulfillment-bar',
        fulfillmentStatus: 'line-fulfillment-status',
      },
    },
    drawdown: {
      requestButton: 'drawdown-flow-button',
      // Modal
      modal: 'drawdown-modal',
      modalCloseButton: 'drawdown-modal--close',
      continueButton: 'drawdown-continue-button',
      // Drawdown List
      drawdownList: {
        notes: 'drawdown-list-notes',
        errorMessage: 'drawdown-list-errorMessage',
        amountItem: 'drawdown-list-amountItem',
        requiresReviewCheckbox: 'drawdown-list-review-checkbox',
        requiresReviewBanner: 'drawdown-list-required-review-banner',
        overdraftBanner: 'drawdown-list-overdraft-banner',
        // Pass in `productVariantNumber` property
        amountInput: 'drawdown-list-amount',
        amountInputDataId: (id: string) => `drawdown-list-amount-${id}`,
        amountTotalWeightDataId: (id: string) => `drawdown-list-convertedAmount-${id}`,
        amountAvailableDataId: (id: string) => `drawdown-list-availableAmount-${id}`,
      },
    },
    editPrice: {
      modal: 'edit-price-modal',
      unitPrice: 'edit-price-unit-price',
      unitPriceHelperText: 'edit-price-unit-price-helper-text',
      revertChanges: ' edit-price-revert-changes',
      saveChanges: 'edit-price-save-changes',
    },

    product: {
      tabView: {
        pastProductsTab: 'product-past-products-tab',
        pastProductsTabPanel: 'product-past-products-tab-panel',
        allProductsTab: 'product-all-products-tab',
        allProductsTabPanel: 'product-all-products-tab-panel',
      },
      card: {
        chip: 'product-card-chip',
        card: 'product-card',
        alternative: 'product-card-alternative',
        name: 'product-list-product-name',
        SKU: 'product-list-product-sku',
        lastOrdered: 'product-list-product-last-ordered',
        quantity: 'product-list-product-quantity',
        size: 'product-list-product-size',
        colour: 'product-list-product-colour',
        image: 'product-list-product-image',
        nationalPrice: 'product-list-product-national-price',
        discountedPrice: 'product-list-product-discounted-price',
        priceNotAvailable: 'product-list-product-price-not-available',
        helpButton: 'product-help-button',
        requestQuoteButton: 'product-request-quote-button',
        orderButton: 'product-order-button',
        showOptionsButton: 'product-show-options-button',
        enquireButton: 'product-enquire-button',
        discountBanner: 'product-discount-banner',
        cartRemoveButton: 'cart-remove-button',
        statusBadge: 'product-card-status-badge',
        editPriceButton: 'product-edit-price-button',
      },
      list: {
        clearFilterButton: 'clear-filter-button',
        paginationCounter: 'product-pagination-counter',
        pageNumber: 'product-pageNumber',
        sortingDropdown: 'product-sort-type',
        noProducts: 'no-products',
        noProductsByFilters: 'no-products-by-filters',
      },
      cover: {
        card: 'product-cover-card',
        cardId: (id: string) => `product-cover-card-${id}`,
        title: 'product-cover-title',
        description: 'product-cover-description',
      },
      variant: {
        sizeDropdown: 'add-variant-size-dropdown',
        sizeDropdownItem: 'add-variant-size-dropdown-item',
        colourDropdown: 'add-variant-colour-dropdown',
        colourDropdownItem: 'add-variant-colour-dropdown-item',
      },
      details: {
        container: 'product-details-container',
        descriptionContainer: 'product-details-description',
        tabOverview: 'product-details-tab-overview',
        tabProductDetails: 'product-details-tab-details',
        orderButton: 'product-details-order-button',
        enquireButton: 'product-details-enquire-button',
        requestQuoteButton: 'product-details-request-quote-button',
        longDescription: 'product-details-long-description',
        shortDescription: 'product-details-short-description',
        itemInformation: `product-details-item`,
      },
    },

    cart: {
      list: {
        title: 'cart-title',
      },
      summary: {
        pickUpButton: 'cart-summary-pickup-button',
        errorMessage: 'cart-summary-error-message',
        continueButton: 'cart-submit-order-button',
        requestCartQuote: 'request-cart-quote-button',
        addNotesButton: 'cart-add-notes-button',
        addInternalNotesButton: 'cart-add-internal-notes-button',
        notesField: 'cart-notes-field',
        internalNotesField: 'cart-internal-notes-field',
        customerRefField: 'cart-reference-field',
        deliveryCostNotice: 'cart-delivery-cost-notice',
        orderChargedMessage: 'cart-order-charged-message',
        urgentDeliveryWarning: 'cart-urgent-delivery-warning',
      },
    },
    quotes: {
      sendOffer: {
        note: 'quote-details-send-offer-notes',
        lock: 'quote-details-send-offer-lock',
        expiry: 'quote-details-send-offer-expiry',
        expiryError: 'quote-details-send-offer-expiry-error',
        freight: 'quote-details-send-offer-freight',
        location: 'quote-details-send-offer-location',
      },
      declineOffer: {
        radioGroup: 'quote-decline-radio',
        tooExpensive: 'quote-decline-too-expensive',
        noLongerNeedIt: 'quote-decline-no-longer-need-it',
        alreadyPurchased: 'quote-decline-already-purchased',
        other: 'quote-decline-other',
        reject: 'quote-decline-reject',
      },
      details: {
        quoteLocked: 'quote-details-quote-locked',
      },
      filters: {
        quoteNumber: 'search-quote-no',
        expiringSoon: 'expiring-soon',
      },
      list: {
        noQuotes: 'no-quotes',
        loadMore: 'quotes-load-more-button',
        loadMoreError: 'quotes-load-more-error-msg',
        paginationCounter: 'quotes-pagination-counter',
      },
      card: {
        card: 'quote-card',
        title: 'quote-title',
        expiryDate: 'quote-expiry-date',
        totalCost: 'quote-total-cost',
        savings: 'quote-savings',
        status: 'quote-status',
        type: 'quote-type',
        numberOfItems: 'quote-number-of-items',
      },
      summary: {
        title: 'quote-summary-title',
        addNotesButton: 'quote-add-notes-button',
        notesField: 'quote-summary-notes-field',
        continueButton: 'quote-continue-button',
        pickUpButton: 'quote-pick-up-button',
        orderChargedMessage: 'quote-order-charged-message',
        freightUpdateMessage: 'quote-freight-update-message',
      },
    },
    orders: {
      filters: {
        orderNumber: 'search-order-no',
        pickUpOnlyCheckbox: 'pickup-only-checkbox',
        seedOnlyCheckbox: 'seed-only-checkbox',
        hideFarmlandsCardOrders: 'hide-farmlands-card-orders',
      },
      list: {
        noOrders: 'no-orders',
        loadMore: 'orders-load-more-button',
        loadMoreError: 'orders-load-more-error-msg',
        paginationCounter: 'orders-pagination-counter',
      },
      card: {
        card: 'order-card',
        title: 'order-title',
        customerRef: 'order-customer-reference',
        placedDate: 'order-placed-date',
        totalCost: 'order-total-cost',
        savings: 'order-savings',
        status: 'order-status',
        type: 'order-type',
        numberOfItems: 'number-of-items',
        cardVendor: 'order-card-vendor',
      },
      summary: {
        title: 'order-summary-title',
        customerInfo: 'order-summary-customerInfo',
        totalCost: 'order-summary-total-cost',
        gst: 'order-summary-gst-cost',
        discountCost: 'order-summary-discount-cost',
        deliveryFee: 'order-summary-delivery-fee',
      },
      details: {
        orderPlaced: 'od-order-placed',
        customerReference: 'od-customer-reference',
        totalCost: 'od-total-cost',
        totalSavings: 'od-total-savings',
        orderType: 'od-order-type',
        cardVendor: 'od-card-vendor',
        notes: 'od-notes',
        internalNotes: 'od-internal-notes',
        priceEditedBanner: 'od-price-edited-banner',
        shareOrder: 'shareOrder',
      },
      deliveryDetails: {
        deliveryName: 'od-delivery-name',
        address: 'od-delivery-address',
      },
      pickUpDetails: {
        orderOriginLabel: 'od-order-origin-label',
        storeName: 'od-store-name',
        address: 'od-store-address',
        phoneNumber: 'od-phone-number',
        emailAddress: 'od-email-ddress',
      },
    },

    checkout: {
      confirmationId: 'checkout-confirmation-id',
      contactModal: 'checkout-contact-modal',
      contactModalSubmit: 'checkout-modal-submit',
    },

    pickUpStore: {
      modal: 'pickup-store-modal',
      selectedStoreBranchName: 'selected-store-name',
      selectedStoreAddress: 'selected-store-address',
      selectedOpenHours: 'selected-store-open-hours',
      searchStoreField: 'search-pickup-store-field',
      storeListItem: 'pickup-store-list-item',
      saveButton: 'pickup-store-save-button',
    },

    pickupStoreSwitch: {
      modal: 'pickup-store-switch-modal',
      reviewItems: 'pickup-store-switch-modal-review-items',
      close: 'pickup-store-switch-modal--close',
    },

    requestQuote: {
      modal: 'request-a-quote-modal',
      bulkBanner: 'request-quote-bulk-banner',
      nameInput: 'request-quote-name-input',
      emailInput: 'request-quote-email-input',
      nameDisplay: 'request-quote-name-display',
      emailDisplay: 'request-quote-email-display',
      phoneInput: 'request-quote-phone-input',
      notesInput: 'request-quote-notes-input',
      submitButton: 'request-quote-submit-button',
      submitError: 'request-quote-api-error',
    },

    stock: {
      status: 'stock-status',
      urgentDeliveryBanner: 'urgent-delivery-banner',
      storeAvailabilitiesModal: 'store-availabities-modal',
      storeAvailabilitiesLink: 'store-availabilities-modal-link',
    },

    stockChangesAlert: {
      modal: 'stock-changes-alert-modal',
      reviewItems: 'stock-changes-alert-modal--review-items',
      close: 'stock-changes-alert-modal--close',
    },

    declarations: {
      openDeclarations: 'open-declarations-button',
      modal: 'declarations-modal',
      modalCloseButton: 'declarations-modal--close',
      downloadAllButton: 'declarations-download-all-button',
    },
    seed: {
      name: {
        input: 'seed-name-modal-input',
        closeButton: 'seed-name-modal-close-button',
      },
      notEnoughSeedsError: 'not-enough-seeds-error',
      seedSearch: {
        separateSeed: 'seed-order-separate-seed',
        addToMix: 'seed-order-add-to-mix',
      },
      address: {
        pickup: 'branch-pickup',
        seedStore: 'seed-store-pickup',
        delivery: 'delivery',
        error: 'no-fulfillment-selected-error',
      },
      paddock: {
        hectareInput: 'paddock-hectare-input',
        nameInput: 'paddock-name-input',
        dateInput: 'paddock-date-input',
        dateInputError: 'paddock-date-input-error',
        notEnoughPaddocksError: 'not-enough-paddocks-error',
      },
      product: {
        quantity: 'product-quantity-input',
        sowingRate: 'product-sowing-rate-input',
        treatment: 'product-treatment-input',
        notEnoughProductsError: 'not-enough-products-error',
        singleSeedInCustomSeed: 'single-seed-in-custom-seed',
      },
      note: {
        internalNote: 'seed-order-internal-note',
        externalNote: 'seed-order-external-note',
      },
    },
  },

  components: {
    address: {
      forPickup: 'address-pickup-button',
      forDelivery: 'address-delivery-button',
      instructionsField: 'drawdown-address-instructions',
      datePickerInput: 'drawdown-address-preferred-delivery-time',
      dairySupplyInput: 'drawdown-daddress-dairy-supply-input',
      addressName: 'drawdown-address-name-input',
      saveAddress: 'drawdown-address-save',
      deliveryDateErrorMessage: 'drawdown-address-deliveryDateErrorMessage',
      editButton: 'drawdown-address-edit-button',
      searchInput: 'drawdown-address-search-input',
      knownAddressItem: 'drawdown-address-known-address-item',
      // Pass in `fulladdress` property
      knownAddressDataId: (id: string) => `drawdown-address-known-address-${id}`,
      searchAddressItem: 'drawdown-search-address-item',
      // Pass in `UniqueId` property
      searchAddressDataId: (id: string) => `drawdown-address-search-address-${id}`,
      urgentDelivery: 'address-urgent-delivery',
    },
    filters: {
      searchProductField: 'product-search-field',
      searchProductFieldMenuItem: 'product-search-menuItem',
      categoryDropdownMenuItem: 'product-filter-category-menuitem',
      categoryDropdownMenuItemDataId: (id: string) => `product-filter-category-menuitem-${id}`,
      timeSelector: 'product-filter-time',
      dateSelector: 'product-filter-daterange',
      fromDatePicker: 'product-filter-daterange-from',
      toDatePicker: 'product-filter-daterange-to',
      fromPrice: 'product-filter-pricerange-from',
      toPrice: 'product-filter-pricerange-to',
      categoryChip: 'product-category-chip-menu',
      dateRangeChip: 'product-date-range-chip-menu',
      priceRangeChip: 'product-price-range-chip-menu',
      viewResults: 'product-chip-menu-view-results',
      inStockCheckbox: 'product-filter-in-stock-checkbox',
    },

    accountSwitch: {
      selector: 'account-selector',
      switcher: 'account-switcher',
      chip: 'account-chip',
      menuItem: 'account-switcher-menuItem',
      message: 'account-switch-message',
      searchBar: 'account-switcher-search-bar',
      alertModal: 'account-alert-modal',
      switchAccountButton: 'account-switch-account-button',
      viewCart: 'account-switch-view-cart',
      recentViews: 'account-recent-views',
    },

    cartHeader: {
      cartShortcutButton: 'header-cart-shortcut',
      inboxButton: 'header-inbox-shortcut',
      pickupDeliveryShortcutButton: 'header-pickup-shortcut',
    },

    statusHeader: {
      container: 'status-header',
      title: 'status-header-title',
      subtitle: 'status-header-subtitle',
      statusBadge: 'status-header-status-badge',
      text: 'status-header-text',
    },

    helperMessage: {
      container: 'product-help-message',
    },

    pagination: {
      number: 'pagination-number',
      clearFilterButton: 'clear-filter-button',
      sortingDropdown: 'product-sort-type',
    },

    counter: {
      amount: 'add-quantity-amount',
      removeButton: 'add-quantity-reduce',
      addButton: 'add-quantity-add',
    },
    contactCard: {
      card: 'checkout-contact-card',
      title: 'contact-card-title',
      phone: 'contact-card-phone',
      storeName: 'contact-card-store-name',
      storeAddress: 'contact-card-store-address',
      storeDirection: 'contact-card-store-direction',
    },
    bottomDrawer: {
      agreements: 'bottom-drawer-agreement',
      pastProducts: 'bottom-drawer-past-products',
      declarations: 'bottom-drawer-declarations',
      quotes: 'bottom-drawer-quotes',
      orders: 'bottom-drawer-orders',
      logout: 'bottom-drawer-logout',
      home: 'bottom-drawer-home',
      more: 'bottom-drawer-more',
      seed: 'bottom-drawer-seed',
    },
    sideDrawer: {
      agreements: 'drawer-agreement',
      pastProducts: 'drawer-past-products',
      seed: 'drawer-seed',
      quotes: 'drawer-quotes',
      orders: 'drawer-orders',
      logout: 'drawer-logout',
      home: 'drawer-home',
      termsAndConditions: 'terms-and-conditions',
      account: 'drawer-account',
      version: 'drawer-version',
    },
    quickActions: {
      productShortcut: 'quickActions-productShortcut',
      agreementShortcut: 'quickActions-agreementShortcut',
    },
    stepper: {
      step: 'stepper-step-of-steps',
      back: 'stepper-back-button',
    },
    treeView: {
      treeView: 'tree-view',
      nodeTestId: 'tree-view-node',
      nodeDataId: (pathName: string) => 'tree-node-' + pathName.replaceAll('/', '.'),
      downloadFileButton: 'download-file-button',
    },

    breadcrumbs: {
      container: 'breadcrumbs-container',
      item: (itemName: string) => `breadcrumb-item-${itemName}`,
    },

    backButton: {
      productDetails: 'back-button-product-details',
    },

    loader: {
      searchProduct: 'loader-search-product',
    },

    // Contact Info Inputs
    contactInfo: {
      nameInput: 'contact-name-input',
      emailInput: 'contact-email-input',
      phoneInput: 'contact-phone-input',
      refInput: 'contact-reference-input',
    },

    searchWidget: {
      searchBar: 'search-widget-search-bar',
      radioButtonGroup: 'search-widget-radio-button-group',
      radioButtonGroupDataId: (id: string) => `search-widget-radio-button-group-${id}`,
      searchIcon: 'search-widget-search-icon',
    },
  },
}

export default TestIds
